export const SET_FOLLOWING_STRATEGIES = 'SET_FOLLOWING_STRATEGIES';
export const FOLLOW_STRATEGY = 'FOLLOW_STRATEGY';
export const UNFOLLOW_STRATEGY = 'UNFOLLOW_STRATEGY';

export const setFollowingStrategies = strategies => ({
  type: SET_FOLLOWING_STRATEGIES,
  payload: strategies,
});

export const followStrategy = (strategy, subsAmount) => dispatch => {
  dispatch({
    type: FOLLOW_STRATEGY,
    payload: {...strategy, subsAmount},
  });
};

export const unfollowStrategy = strategyId => dispatch => {
  dispatch({
    type: UNFOLLOW_STRATEGY,
    payload: strategyId,
  });
};
